import React from 'react';

import { TableSort } from 'components/WrappedComponents/Table/types';

import DownloadButton from './DownloadButton/DownloadButton';
import { FilterDashboardAutoriteFourriere } from './Filters/types';
import Filters from './Filters';

import './DashboardHeader.less';

interface DashboardHeaderProps<SortType extends string | undefined> {
  totalResult: number;
  filter: Partial<FilterDashboardAutoriteFourriere>;
  setFilter: (value: Partial<FilterDashboardAutoriteFourriere>) => void;
  sort: TableSort<SortType>;
}

function DashboardHeader<SortType extends string | undefined>({
  totalResult,
  filter,
  setFilter,
  sort,
}: DashboardHeaderProps<SortType>): React.ReactElement {
  const countString = `${totalResult} ${
    totalResult > 1 ? 'véhicules trouvés' : 'véhicule trouvé'
  }`;

  return (
    <div>
      <div className="dashboard-header-fields">
        <Filters filter={filter} setFilter={setFilter} />
        <div className="dashboard-header-actions">
          <DownloadButton filters={filter} sort={sort} />
        </div>
      </div>

      <p className="dashboard-number-vehicules">{countString}</p>
    </div>
  );
}

export default DashboardHeader;
